<avr-footer>
    <footer class="bg-master-darker">
    <div class="container">
        <div class="row p-t-15 p-b-15">
            <div class="col">
                <p class="text-center mb-0 text-white lead">Aeroviewer Stats:</p>
                <p class="text-center text-white text-muted"><strong>800.000</strong> Aerial Photos /
                    <strong>300</strong> Hours of
                    Aerial Video</p>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-md-2 offset-md-1">
                <p class="lead mb-0 text-white">AeroViewer</p>
                <ul class="list-unstyled">
                    <li>
                        <a href="/" class="text-muted text-white">Home</a>
                    </li>


                    <li>
                        <a class="text-muted text-white"
                           href="/photo-select">Photos</a>
                    </li>

                    <li>
                        <a class="text-muted text-white"
                           href="/footage-select">Footage</a>
                    </li>

                    <li>
                        <a class="text-muted text-white "
                           href="/collection-select">collections</a>
                    </li>

                    <li>
                        <a class="text-muted text-white "
                           href="/digishare">DigiShare</a>
                    </li>

                    <li>
                        <a class="text-muted text-white "
                           href="/contributors">Contributors</a>
                    </li>
                    <li>
                        <a class="text-muted text-white"
                           href="/about">About</a>
                    </li>

                    <li>
                        <a class="text-muted text-white"
                           href="/pricing">Pricing</a>
                    </li>

                </ul>
            </div>
            <div class="col-md-2 offset-md-1">
                <p class="lead mb-0 text-white">Help</p>
                <ul class="list-unstyled">
                    <li>
                        <a href="/contact" class="text-muted text-white">Contact Us</a>
                    </li>
                </ul>
            </div>
            <div class="col-md-3">
                <p class="lead mb-0 text-white">Legal</p>

                <ul class="list-unstyled">
                    <li>
                        <a href="/privacy-policy" class="text-muted text-white">Privacy Policy</a>
                    </li>

                    <li>
                        <a href="/terms-of-use" class="text-muted text-white">General Terms of Use</a>
                    </li>

                    <li>
                        <a href="/content-licenses-agreement" class="text-muted text-white">Content Licenses
                            Agreement</a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <p class="lead text-center text-white">Follow Us</p>
                <ul class="list-inline text-center">
                    <li class="list-inline-item">
                        <a class="text-muted text-white" href="https://www.facebook.com/tripinview" target="_blank">
                            <i class="fa fa-facebook"></i>
                        </a>
                    </li>
                    <li class="list-inline-item">
                        <a class="text-muted text-white" href="https://twitter.com/tripinview" target="_blank">
                            <i class="fa fa-twitter"></i>
                        </a>
                    </li>
                    <li class="list-inline-item">
                        <a class="text-muted text-white" href="https://www.linkedin.com/company/geotag-aeroview"
                           target="_blank">
                            <i class="fa fa-linkedin"></i>
                        </a>
                    </li>
                    <li class="list-inline-item">
                        <a class="text-muted text-white" href="https://www.youtube.com/c/Tripinview" target="_blank">
                            <i class="fa fa-youtube"></i>
                        </a>
                    </li>
                    <li class="list-inline-item">
                        <a class="text-muted text-white" href="https://www.pinterest.com/tripinview1/"
                           target="_blank">
                            <i class="fa fa-pinterest"></i>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="row p-t-15 p-b-15">
            <div class="col text-center">
                <small class="text-muted text-white">Copyright 2018-2019 Geotag Aeroview S.A. All Rights Reserved.
                </small>
            </div>
        </div>
    </div>
</footer>

</avr-footer>


// WEBPACK FOOTER //
// avr_eshop/frontend/components/avr-footer/avr-footer.tag.html